import React, { useState, useEffect } from 'react';
import Card from '../components/ui/Card';
import { contactService } from '../services/contactService';
import './Contacts.css';

const Contacts = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchContacts = async () => {
  try {
    setLoading(true);
    setError('');
    
    console.log('🔄 Fetching contacts...');
    const response = await contactService.getContacts();
    
    console.log('✅ API Response:', response);
    
    // CORRECTION : Adaptez selon la structure réelle de votre réponse
    if (response && response.contacts) {
      // Cas 1: { contacts: [...], total: ... }
      setContacts(response.contacts || []);
    } else if (response && response.data && response.data.contacts) {
      // Cas 2: { success: true, data: { contacts: [...] } }
      setContacts(response.data.contacts || []);
    } else if (response && response.success && response.data && response.data.contacts) {
      // Cas 3: { success: true, data: { contacts: [...] } } (format complet)
      setContacts(response.data.contacts || []);
    } else if (Array.isArray(response)) {
      // Cas 4: réponse est directement un tableau
      setContacts(response);
    } else if (response && response.data && Array.isArray(response.data)) {
      // Cas 5: { success: true, data: [...] }
      setContacts(response.data || []);
    } else {
      setContacts([]);
      console.warn('⚠️ Format de réponse inattendu:', response);
    }
    
  } catch (err) {
    console.error('❌ API Error:', err);
    setError(err.message || 'Erreur lors du chargement des messages');
    setContacts([]);
  } finally {
    setLoading(false);
  }
};

  // Chargement initial
  useEffect(() => {
    fetchContacts();
  }, []);

  // Formater la date
  const formatDate = (dateString) => {
    if (!dateString) return 'Date inconnue';
    return new Date(dateString).toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Obtenir l'icône selon le type de message
  const getMessageIcon = (contact) => {
    if (contact.company) return '🏢';
    if (contact.phone) return '📱';
    if (contact.email) return '📧';
    return '💬';
  };

  if (loading) {
    return (
      <div className="contacts">
        <div className="page-header">
          <div className="page-title">
            <h1>Messages de Contact</h1>
            <p>Chargement...</p>
          </div>
        </div>
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>Chargement des messages...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="contacts">
      {/* En-tête de page */}
      <div className="page-header">
        <div className="page-title">
          <h1>Messages de Contact</h1>
          <p>Consultez les messages reçus via le formulaire de contact</p>
        </div>
        
        <div className="header-actions">
          <div className="filters">
            <div className="contacts-stats">
              <span className="stat-badge">
                📨 {contacts.length} message{contacts.length !== 1 ? 's' : ''}
              </span>
            </div>
            
            <button 
              onClick={fetchContacts}
              className="refresh-btn"
            >
              🔄 Actualiser
            </button>
          </div>
        </div>
      </div>

      {/* Message d'erreur */}
      {error && (
        <Card className="error-card" padding="md">
          <div className="error-message">
            <span>❌</span>
            {error}
            <button onClick={() => setError('')} className="error-close">✕</button>
          </div>
        </Card>
      )}

      {/* Statistiques rapides */}
      <div className="contacts-stats-grid">
        <Card className="stat-card" padding="lg">
          <div className="stat-content">
            <div className="stat-icon">📨</div>
            <div className="stat-info">
              <div className="stat-number">{contacts.length}</div>
              <div className="stat-label">Messages totaux</div>
            </div>
          </div>
        </Card>
        
        <Card className="stat-card" padding="lg">
          <div className="stat-content">
            <div className="stat-icon">🏢</div>
            <div className="stat-info">
              <div className="stat-number">
                {contacts.filter(c => c.company).length}
              </div>
              <div className="stat-label">Avec entreprise</div>
            </div>
          </div>
        </Card>
        
        <Card className="stat-card" padding="lg">
          <div className="stat-content">
            <div className="stat-icon">📱</div>
            <div className="stat-info">
              <div className="stat-number">
                {contacts.filter(c => c.phone).length}
              </div>
              <div className="stat-label">Avec téléphone</div>
            </div>
          </div>
        </Card>

        <Card className="stat-card" padding="lg">
          <div className="stat-content">
            <div className="stat-icon">👥</div>
            <div className="stat-info">
              <div className="stat-number">
                {contacts.filter(c => c.employees).length}
              </div>
              <div className="stat-label">Avec nombre employés</div>
            </div>
          </div>
        </Card>
      </div>

      {/* Grille des messages */}
      <div className="contacts-grid">
        {contacts.map(contact => {
          const messageIcon = getMessageIcon(contact);
          
          return (
            <Card key={contact._id} className="contact-card" padding="lg">
              {/* En-tête du message */}
              <div className="contact-header">
                <div className="contact-sender">
                  <span className="sender-icon">{messageIcon}</span>
                  <span className="sender-name">
                    {contact.name || 'Anonyme'}
                  </span>
                </div>
                <div className="contact-badges">
                  <span className="date-badge">
                    {formatDate(contact.createdAt)}
                  </span>
                </div>
              </div>

              {/* Informations de contact */}
              <div className="contact-info">
                <div className="info-row">
                  <span className="info-label">Email:</span>
                  <span className="info-value">
                    <a href={`mailto:${contact.email}`} className="email-link">
                      {contact.email || 'Non spécifié'}
                    </a>
                  </span>
                </div>
                
                {contact.phone && (
                  <div className="info-row">
                    <span className="info-label">Téléphone:</span>
                    <span className="info-value">
                      <a href={`tel:${contact.phone}`} className="phone-link">
                        {contact.phone}
                      </a>
                    </span>
                  </div>
                )}
                
                {contact.company && (
                  <div className="info-row">
                    <span className="info-label">Entreprise:</span>
                    <span className="info-value">{contact.company}</span>
                  </div>
                )}
                
                {contact.employees && (
                  <div className="info-row">
                    <span className="info-label">Nombre d'employés:</span>
                    <span className="info-value">{contact.employees}</span>
                  </div>
                )}
              </div>

              {/* Message */}
              <div className="contact-message-section">
                <div className="message-header">
                  <span className="message-label">📝 Message:</span>
                </div>
                <div className="message-content">
                  {contact.message || 'Aucun message'}
                </div>
              </div>

              {/* Actions */}
              <div className="contact-actions">
                <div className="quick-actions">
                  <a 
                    href={`mailto:${contact.email}?subject=Réponse à votre message`}
                    className="action-btn reply-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📧 Répondre
                  </a>
                  
                  {contact.phone && (
                    <a 
                      href={`tel:${contact.phone}`}
                      className="action-btn call-btn"
                    >
                      📱 Appeler
                    </a>
                  )}
                </div>
              </div>
            </Card>
          );
        })}
      </div>

      {/* État vide */}
      {contacts.length === 0 && !loading && (
        <Card className="empty-state">
          <div className="empty-icon">📭</div>
          <h3 className="empty-title">Aucun message de contact</h3>
          <p className="empty-text">
            Aucun message n'a été reçu via le formulaire de contact pour le moment.
          </p>
          <button 
            onClick={fetchContacts}
            className="refresh-btn-large"
          >
            🔄 Actualiser
          </button>
        </Card>
      )}
    </div>
  );
};

export default Contacts;